import {Theme, createStyles} from '@material-ui/core';
import {CreateCSSProperties} from '@material-ui/styles/withStyles/withStyles';

const commonTriangleStyles = (theme: Theme): CreateCSSProperties => ({
	zIndex: 0,
	position: 'absolute',
	backgroundColor: 'inherit',
	borderRadius: 0,

	'&, &::before, &::after': {
		content: '""',
		display: 'block',
		position: 'absolute',
		backgroundColor: 'inherit',
		width: theme.spacing(7),
		height: theme.spacing(7),
		bottom: theme.spacing(0.8),
		borderRadius: theme.spacing(1.5),
	},
	'&::before': {
		transform: 'rotate(-135deg) skewX(-45deg) scale(1.414,.707) translate(0,-50%)',
	},
	'&::after': {
		transform: 'rotate(135deg) skewY(-45deg) scale(.707,1.414) translate(50%)',
		borderBottomRightRadius: 0,
		borderTopLeftRadius: 0,
	},
});

const commonBalloonStyles = (theme: Theme): CreateCSSProperties => ({
	borderRadius: theme.spacing(5),
	maxWidth: '80%',
});

export const messageBalloonStyles = (theme: Theme) =>
	createStyles({
		root: {
			position: 'relative',
		},
		left: {
			...commonBalloonStyles(theme),
			position: 'relative',
			zIndex: 2,
		},
		right: {
			...commonBalloonStyles(theme),
			position: 'relative',
			zIndex: 1,
		},
		triangle: {
			...commonTriangleStyles(theme),
			transform: 'rotate(45deg)',
			left: theme.spacing(5),
			borderBottomRightRadius: 0,
		},
		triangleRight: {
			...commonTriangleStyles(theme),
			right: theme.spacing(5),
		},
	});
